import React, { useEffect, useRef } from "react";
import { AudioContext } from "./AudioContext";
import { urlAssetsCustom } from "utils/common";

const AudioProvider = ({ children }) => {
  const audioRef = useRef(null);
  const unlockedRef = useRef(false);
  const videoPlayingCount = useRef(0);

  // unlock audio (chỉ 1 lần)
  const unlockAudio = () => {
    if (unlockedRef.current) return;

    const audio = audioRef.current;
    if (!audio) return;

    audio.volume = 0.6;

    audio
      .play()
      .then(() => {
        unlockedRef.current = true;
        audio.pause();
      })
      .catch(() => {});
  };

  const playAudio = () => {
    if (!unlockedRef.current) return;
    if (videoPlayingCount.current > 0) return;

    audioRef.current?.play().catch(() => {});
  };

  const pauseAudio = () => {
    audioRef.current?.pause();
  };

  // ===== Video hooks =====
  const onVideoPlay = () => {
  videoPlayingCount.current += 1;
  console.log("[VIDEO PLAY]", {
    videoPlayingCount: videoPlayingCount.current,
  });
  pauseAudio();
};

const onVideoPause = () => {
  videoPlayingCount.current = Math.max(
    0,
    videoPlayingCount.current - 1
  );

  console.log("[VIDEO PAUSE]", {
    videoPlayingCount: videoPlayingCount.current,
  });

  if (videoPlayingCount.current === 0) {
    playAudio();
  }
};

  // ===== User gesture =====
  useEffect(() => {
    const handleClick = () => {
      if (!unlockedRef.current) {
        unlockAudio();
      }
    };

    const handleScroll = () => {
      if (!unlockedRef.current) {
        unlockAudio();
      }
      playAudio();
    };

    document.addEventListener("click", handleClick);
    document.addEventListener("touchstart", handleClick, { once: true });
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("touchstart", handleClick);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // ===== YouTube iframe listener =====
  useEffect(() => {
    const handleYoutubeMessage = (event) => {
      if (!event.data) return;

      let data;
      try {
        data =
          typeof event.data === "string"
            ? JSON.parse(event.data)
            : event.data;
      } catch {
        return;
      }

      if (data.event !== "onStateChange") return;

      const state = data.info;

      // 1 = playing
      if (state === 1) {
        onVideoPlay();
      }

      // 2 = paused, 0 = ended
      if (state === 2 || state === 0) {
        onVideoPause();
      }
    };

    window.addEventListener("message", handleYoutubeMessage);
    return () => {
      window.removeEventListener("message", handleYoutubeMessage);
    };
  }, []);

  return (
    <AudioContext.Provider
      value={{
        playAudio,
        pauseAudio,
        onVideoPlay,
        onVideoPause,
      }}
    >
      <audio ref={audioRef} loop preload="auto">
        <source
          src={urlAssetsCustom("assets/img/MASTER_SUNLIGHT.mp3")}
          type="audio/mpeg"
        />
      </audio>
      {children}
    </AudioContext.Provider>
  );
};

export default AudioProvider;
